<template>
  <div>
    <div class="h-i-4">
      <div class="i-4-c">
        <!-- <div class="i-4-1">Cooperation</div> -->
        <div class="i-4-2">合作伙伴</div>
        <div class="i-4-3">携手合作伙伴，见证服务品质</div>
        <div class="i-4-4">
          <div v-for="(item, index) in partnerList" :key="index" style="width: 33%;">
            <div
              v-if="item.id == 1 || item.id == 4 ||
              item.id == 7 || item.id == 10"
              class="i-c-c-1"
            >
              <img :src="item.icon" alt="">
            </div>
            <div
              v-if="
              item.id == 2 || item.id == 5 ||
              item.id == 8 || item.id == 11"
              class="i-c-c-2"
            >
              <img :src="item.icon" alt="">
            </div>
            <div
              v-if="
              item.id == 3 || item.id == 6 ||
              item.id == 9 || item.id == 12"
              class="i-c-c-3"
            >
              <img :src="item.icon" alt="">
            </div>
          </div>
          <!-- <div class="i-c-c-2">
            <img src="../assets/img/cooperation/partner2.png" alt="">
          </div>
          <div class="i-c-c-3">
            <img src="../assets/img/cooperation/partner3.png" alt="">
          </div> -->
        </div>
        <div class="i-4-5">深入行业内部，更专业，所以更值得信赖！</div>
        <div class="i-4-6" @click="demand">
          联系我们
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      partnerList: [
        {
          id: 1,
          icon: require('../assets/img/cooperation/img/h1.png')
        },
        {
          id: 2,
          icon: require('../assets/img/cooperation/img/h2.png')
        },
        {
          id: 3,
          icon: require('../assets/img/cooperation/img/h3.png')
        },
        {
          id: 4,
          icon: require('../assets/img/cooperation/img/h4.png')
        },
        {
          id: 5,
          icon: require('../assets/img/cooperation/img/h5.png')
        },
        {
          id: 6,
          icon: require('../assets/img/cooperation/img/h6.png')
        },
        {
          id: 7,
          icon: require('../assets/img/cooperation/img/h7.png')
        },
        {
          id: 8,
          icon: require('../assets/img/cooperation/img/h8.png')
        },
        {
          id: 9,
          icon: require('../assets/img/cooperation/img/h9.png')
        },
        {
          id: 10,
          icon: require('../assets/img/cooperation/img/h10.png')
        },
        {
          id: 11,
          icon: require('../assets/img/cooperation/img/h11.png')
        },
        {
          id: 12,
          icon: require('../assets/img/cooperation/img/h12.png')
        }
        // {
        //   id: 13,
        //   icon: require('../assets/img/cooperation/partner13.png')
        // },
        // {
        //   id: 14,
        //   icon: require('../assets/img/cooperation/partner14.png')
        // },
        // {
        //   id: 15,
        //   icon: require('../assets/img/cooperation/partner15.png')
        // },
        // {
        //   id: 16,
        //   icon: require('../assets/img/cooperation/partner16.png')
        // },
        // {
        //   id: 17,
        //   icon: require('../assets/img/cooperation/partner17.png')
        // },
        // {
        //   id: 18,
        //   icon: require('../assets/img/cooperation/partner18.png')
        // }
      ]
    }
  },
  methods: {
    demand() { // 跳转客服
      // window.open()
      KS.openChatWin()
    }
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 500px) {
  .h-i-4 {
    width: 100%;
    padding: 100px 0px 60px 0px;
    background: url(../assets/img/footer/background.png) no-repeat;
    background-size: 100% 100%;
    // overflow-x:auto;
    .i-4-c {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .i-4-1 {
        font-size: 60px;
        font-family: Source Han Sans CN;
        font-weight: 800;
        color: #141B6A;
        opacity: 0.5;
        -webkit-text-stroke: 1px #46A5FF;
        text-stroke: 1px #46A5FF;
      }
      .i-4-2 {
        font-size: 54px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 50px;
        opacity: 0.99;
      }
      .i-4-3 {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        opacity: 0.5;
        margin-top: 10px;
      }
      .i-4-4 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        .i-c-c-1 {
          // width: 33%;
          margin-top: 60px;
          cursor: pointer;
          img {
            width: 260px;
            height: 70px;
          }
        }
        .i-c-c-2 {
          // width: 33%;
          margin-top: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 260px;
            height: 70px;
          }
        }
        .i-c-c-3 {
          // width: 33%;
          margin-top: 60px;
          display: flex;
          cursor: pointer;
          align-items: center;
          justify-content: flex-end;
          img {
            width: 260px;
            height: 70px;
          }
        }
      }
      .i-4-5 {
        font-size: 50px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 150px;
      }
      .i-4-6 {
        width: 300px;
        height: 70px;
        background: #FFFFFF;
        border-radius: 40px;
        text-align: center;
        line-height: 70px;
        cursor: pointer;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #f11873;
        margin-top: 50px;
      }
    }
  }
}

@media screen and (min-width:359px) and (max-width: 500px) {
  .h-i-4 {
    width: 100%;
    padding: 40px 0px 40px 0px;
    // background: url(../assets/app/ba.png) no-repeat;
    // background-size: 100% 100%;
    .i-4-c {
      width: 90%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // .i-4-1 {
      //   font-size: 35px;
      //   font-family: Source Han Sans CN;
      //   font-weight: 800;
      //   color: #141B6A;
      //   opacity: 0.5;
      //   -webkit-text-stroke: 1px #46A5FF;
      //   text-stroke: 1px #46A5FF;
      // }
      .i-4-2 {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        // margin-top: 45px;
        opacity: 0.99;
      }
      .i-4-3 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        opacity: 0.5;
        margin-top: 10px;
        text-align: center;
      }
      .i-4-4 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        .i-c-c-1 {
          // width: 33%;
          margin-top: 30px;
          cursor: pointer;
          img {
            width: 75%;
            height: 32px;
          }
        }
        .i-c-c-2 {
          // width: 33%;
          margin-top: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 75%;
            height: 32px;
          }
        }
        .i-c-c-3 {
          // width: 33%;
          margin-top: 30px;
          display: flex;
          cursor: pointer;
          align-items: center;
          justify-content: flex-end;
          img {
            width: 75%;
            height: 32px;
          }
        }
      }
      .i-4-5 {
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 50px;
        text-align: center;
      }
      .i-4-6 {
        width: 60%;
        height: 40px;
        background: #FFFFFF;
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #f11873;
        margin-top: 30px;
      }
    }
  }
}
</style>
